import React from "react";
import { useNavigate } from "react-router-dom";
import { getId } from "../../../Components/Functions/word.fun";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

import { titleCaseChange } from "../../../Components/Functions/changeFirstLetterUpperCase";
const tableHead = [
  "Sr.",
  "Project",
  "Po Num",
  "Vendor",
  "VENDOR PO DATE",
  "Status",
  "Business Name",
  "Actions",
];
const AllPurcahseOrderTable = ({ PO = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    id = getId(id);
    navigate(`/purchase-order/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {PO?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.poNumber}>
                <td>{Index}</td>
                <td>
                  {titleCaseChange(item?.projectClientName) ||
                    titleCaseChange(item?.projectBusinessName) ||
                    "Custom PO"}
                </td>
                <td>{item?.poNumber || "N/A"}</td>
                <td>
                  {titleCaseChange(item?.businessName) ||
                    titleCaseChange(item?.contactPersonName) ||
                    "N/A"}
                </td>
                <td>{item?.vendorPurchaseOrderDate || "N/A"}</td>
                <td>
                  {item?.approveStatus ? (
                    <span className="text-white badge bg-success">
                      approved
                    </span>
                  ) : (
                    <span className="text-white badge bg-warning">pending</span>
                  )}
                </td>
                <td>{titleCaseChange(item?.businessName) || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.poNumber)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default AllPurcahseOrderTable;
